import { Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

const pathToPermission: Record<string, string> = {
  "dashboard":  "dashboard",
  "finance":    "finance",
  "hr":         "hr",
  "customers":  "customers",
  "vendors":    "vendors",
  "warehouse":  "warehouse",
  "production": "production",
  "reports":    "reports",
  "chat":       "chat",
  "backup":     "backup",
  "users":      "users",
  "management": "management",
  "settings":   "settings",
};

interface Props {
  children: React.ReactNode;
  page?: string;
}

export default function ProtectedRoute({ children, page }: Props) {
  const { isLoggedIn, loading, currentUser } = useApp();

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex",
        alignItems: "center", justifyContent: "center",
        background: "linear-gradient(160deg,#070714 0%,#0e0e2a 100%)",
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 48, height: 48,
            border: "3px solid rgba(59,130,246,0.2)",
            borderTop: "3px solid #3b82f6",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
            margin: "0 auto 16px",
          }} />
          <div style={{ color: "#64748b", fontSize: 14, fontFamily: "'Vazirmatn','Segoe UI',sans-serif" }}>
            در حال بارگذاری...
          </div>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!isLoggedIn) return <Navigate to="/auth" replace />;

  // ادمین به همه جا دسترسی دارد
  if (currentUser?.role === "admin") return <>{children}</>;

  // چک دسترسی برای صفحات خاص
  if (page) {
    const permKey = pathToPermission[page];
    if (permKey) {
      // صفحه users فقط برای ادمین
      if (page === "users") {
        return (
          <div dir="rtl" style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            minHeight: "60vh", fontFamily: "'Vazirmatn','Segoe UI',sans-serif",
          }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 64, marginBottom: 16 }}>🚫</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#f1f5f9", marginBottom: 8 }}>دسترسی ندارید</div>
              <div style={{ fontSize: 14, color: "#64748b" }}>فقط ادمین می‌تواند این صفحه را ببیند</div>
            </div>
          </div>
        );
      }

      const hasPerm = currentUser?.permissions?.[permKey]?.view;
      if (!hasPerm) {
        return (
          <div dir="rtl" style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            minHeight: "60vh", fontFamily: "'Vazirmatn','Segoe UI',sans-serif",
          }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 64, marginBottom: 16 }}>🚫</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#f1f5f9", marginBottom: 8 }}>دسترسی ندارید</div>
              <div style={{ fontSize: 14, color: "#64748b" }}>شما مجاز به مشاهده این صفحه نیستید</div>
            </div>
          </div>
        );
      }
    }
  }

  return <>{children}</>;
}
